module.exports = __webpack_public_path__ + "img/2-3.ee364311.svg";